import React from 'react';
import {
  accountancyEntry,
  avoidActivities,
  consultationType,
  manualActivities,
  nbConsultations,
  nbInvoices,
  revenue,
} from '../../../data/mappedData';

function ClientDetails(props) {
  return (
    <div className="client-details-container">
      <div className="left-container">
        <div className="detail-container">
          <span className="detail-title">Forme juridique</span>
          <span className="details">{props?.client?.legalForm?.name}</span>
        </div>
        <div className="detail-container">
          <span className="detail-title">Secteur d'activité</span>
          <span className="details">{props?.client?.sector?.description}</span>
        </div>
        <div className="detail-container">
          <span className="detail-title">Nombre de salariés</span>
          <span className="details">{props?.client?.nbEmployees}</span>
        </div>
        <div className="detail-container">
          <span className="detail-title">Turnover cadre</span>
          <span className="details">{props?.client?.turnover}</span>
        </div>
        <div className="detail-container">
          <span className="detail-title">Années d'existence</span>
          <span className="details">
            {props?.client?.nbYearsBusiness} années
          </span>
        </div>
        <div className="detail-container">
          <span className="detail-title">Rythme de consultation</span>
          <span className="details">
            {nbConsultations[props?.client?.nbConsultations]}
          </span>
        </div>
        <div className="detail-container">
          <span className="detail-title">Chiffre d'affaires annuel</span>
          <span className="details">{revenue[props?.client?.revenue]}</span>
        </div>
        <div className="detail-container">
          <span className="detail-title">Nombre de factures</span>
          <span className="details">
            {nbInvoices[props?.client?.nbInvoices]}
          </span>
        </div>
        <div className="detail-container">
          <span className="detail-title">Société soumise à TVA</span>
          <span className="details">
            {props?.client?.vat === true ? 'oui' : 'non'}
          </span>
        </div>
        {props?.client?.clientHasExternalExperts?.length > 0 && (
          <div className="detail-container">
            <span className="detail-title detail-row">
              Le client avait le même expert comptable depuis{' '}
              {props?.client?.clientHasExternalExperts[0]?.yearsCollaboration}{' '}
              ans.
            </span>
          </div>
        )}
      </div>
      <div className="right-container">
        <div className="detail-container">
          <span className="detail-title">Préférence de rendez-vous</span>
          <span className="details">
            {consultationType[props?.client?.consultationType]}
          </span>
        </div>
        <div className="detail-container">
          <span className="detail-title">Jours préférés</span>
          <span className="details">
            {props?.client?.days?.map((day) => day.name).join(', ') ||
              'Aucune préférence'}
          </span>
        </div>
        <div className="detail-container">
          <span className="detail-title">Langues préférées</span>
          <span className="details">
            {props?.client?.skills
              ?.filter(({ category }) => category === 'Langues')
              ?.map(({ name }) => name)
              .join(', ') || 'Aucune préférence'}
          </span>
        </div>
        <div className="detail-container">
          <span className="detail-title">Logiciels préférés</span>
          <span className="details">
            {props?.client?.skills
              ?.filter(({ category }) => category === 'Logiciels')
              ?.map(({ name }) => name)
              .join(', ') || 'Aucune préférence'}
          </span>
        </div>
        <div className="detail-container">
          <span className="detail-title">Types de plan comptable</span>
          <span className="details">
            {props?.client?.skills
              ?.filter(({ category }) => category === 'Principes Comptables')
              ?.map(({ name }) => name)
              .join(', ') || 'Aucune préférence'}
          </span>
        </div>
        <div className="detail-container">
          <span className="detail-title">Activités recherchées</span>
          <span className="details">
            {props?.client?.activities
              ?.filter((activity) => !avoidActivities.includes(activity?.name))
              ?.filter((activity) => !manualActivities.includes(activity?.name))
              ?.map(({ description }) => description)
              .join(', ') || 'Aucune préférence'}
          </span>
        </div>
        <div className="detail-container">
          <span className="detail-title">Activités à estimer manuellement</span>
          <span className="details">
            {props?.client?.activities
              ?.filter((activity) => manualActivities.includes(activity?.name))
              ?.map(({ description }) => description)
              .join(', ') || 'Aucune'}
          </span>
        </div>
        <div className="detail-container">
          <span className="detail-title">Saisie de comptabilité</span>
          <span className="details">
            {accountancyEntry[props?.client?.accountingEntry]}
          </span>
        </div>
        <div className="detail-container">
          <span className="detail-title">Transmission des documents</span>
          <span className="details">
            {props?.client?.transferOption?.label}
          </span>
        </div>
        <div className="detail-container">
          <span className="detail-title">Ville</span>
          <span className="details">{props?.client?.location?.city}</span>
        </div>
      </div>
    </div>
  );
}

export default ClientDetails;
